import React from 'react';
import {
	Box,
	Container,
	VStack,
	HStack,
	Text,
	Link,
	Icon,
	useColorModeValue,
	Divider,
} from '@chakra-ui/react';
import {
	FaLinkedinIn,
	FaInstagram,
	FaFacebook,
	FaTwitter,
} from 'react-icons/fa';
import { IoArrowUp } from 'react-icons/io5';

const AuthenticatedFooter = () => {
	const bgColor = useColorModeValue('gray.50', 'gray.900');
	const textColor = useColorModeValue('gray.700', 'gray.300');
	const borderColor = useColorModeValue('gray.200', 'gray.700');

	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	const navigationLinks = [
		{ label: 'Home', href: '/' },
		{ label: 'About', href: '/about' },
		{ label: 'Projects', href: '/projects' },
		{ label: 'Services', href: '/services' },
		{ label: 'Contact', href: '/contact' },
	];

	const legalLinks = [
		{ label: 'Support', href: '/my-support' },
		{ label: 'Privacy Policy', href: '/privacy' },
		{ label: 'Terms Of Services', href: '/terms' },
		{ label: 'Cookie Settings', href: '/cookies' },
	];

	const socialLinks = [
		{ icon: FaLinkedinIn, href: 'https://linkedin.com', label: 'LinkedIn' },
		{ icon: FaInstagram, href: 'https://instagram.com', label: 'Instagram' },
		{ icon: FaFacebook, href: 'https://facebook.com', label: 'Facebook' },
		{ icon: FaTwitter, href: 'https://twitter.com', label: 'Twitter' },
	];

	return (
		<Box as='footer' bg={bgColor} borderTop='1px solid' borderColor={borderColor}>
			<Container maxW='100%' py={4} px={8}>
				{/* Bottom Section - Copyright and Scroll to Top */}
				<HStack justify='space-between' align='center' pt={6}>
					<Text fontSize='xs' color='gray.500'>
						© {new Date().getFullYear()} OpsPilotCrm. All rights reserved.
					</Text>
					{/* Legal Links */}
					<VStack align={{ base: 'flex-start', md: 'flex-end' }} spacing={2}>
						<HStack
							spacing={4}
							flexWrap='wrap'
							justify={{ base: 'flex-start', md: 'flex-end' }}>
							{legalLinks.map((link) => (
								<Link
									key={link.label}
									href={link.href}
									fontSize='xs'
									color='gray.500'
									transition='color 0.2s'
									_hover={{ color: 'blue.500' }}>
									{link.label}
								</Link>
							))}
							<Box
								as='button'
								onClick={scrollToTop}
								display='flex'
								alignItems='center'
								justifyContent='center'
								w={10}
								h={10}
								ml={6}
								borderRadius='50%'
								bg='blue.500'
								color='white'
								transition='all 0.3s ease'
								cursor='pointer'
								_hover={{
									bg: 'blue.600',
									transform: 'translateY(-2px)',
									boxShadow: 'lg',
								}}
								title='Scroll to top'>
								<Icon as={IoArrowUp} boxSize={5} />
							</Box>
						</HStack>
					</VStack>
				</HStack>
			</Container>
		</Box>
	);
};

export default AuthenticatedFooter;
